"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerWrapper = void 0;
const React = require("react");
const react_1 = require("react");
const RetailCustomerLogin_1 = require("../RetailCustomerLogin");
const RetailCustomerCreateAccount_1 = require("../RetailCustomerCreateAccount");
const RetailSession_1 = require("../../models/RetailSession");
const Button_1 = require("../../../../../components/base/atoms/Button");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const Grid_1 = require("../../../../../components/base/structure/Grid");
const Card_1 = require("../../../../../components/base/structure/Card");
const RetailCustomerResetPasswordRequest_1 = require("../RetailCustomerResetPasswordRequest");
const useClient_1 = require("../../../../../hooks/useClient");
const CustomerPaymentMethodContext_1 = require("../../contexts/CustomerPaymentMethodContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const RetailCustomerVerifyAccount_1 = require("../RetailCustomerVerifyAccount");
const localStorageKey_1 = require("../helpers/localStorageKey");
const css = (0, cssComposer_1.default)(styles, "RetailCustomerWrapper");
const RetailCustomerWrapper = ({ onCompletion, onSignUp }) => {
    const client = (0, useClient_1.useClient)();
    const [createNew, setCreateNew] = (0, react_1.useState)(false);
    const [retailCustomerDetails, setRetailCustomerDetails] = (0, react_1.useState)(null);
    const [isAccountVerificationRequired, setIsAccountVerificationRequired] = (0, react_1.useState)(false);
    const [resetPasswordRequest, setResetPasswordRequest] = (0, react_1.useState)(false);
    // indicates we want to proceed to the next step (may need to wait for session)
    const [proceed, setProceed] = (0, react_1.useState)(false);
    const { isLoading: { fetch: isFetchingPaymentMethod } } = (0, react_1.useContext)(CustomerPaymentMethodContext_1.CustomerPaymentMethodContext);
    const retailCustomer = (0, react_1.useMemo)(() => client.auth.session && client.auth.session.retailCustomer, [client.auth.session]);
    const tryToProceed = (0, react_1.useCallback)(() => {
        setProceed(true);
    }, [setProceed]);
    // check if we can progress to the next step
    (0, react_1.useEffect)(() => {
        if (client.auth.session &&
            client.auth.session.retailCustomerId &&
            !isFetchingPaymentMethod &&
            proceed) {
            onCompletion(client.auth.session);
        }
    }, [proceed, client.auth.session, isFetchingPaymentMethod]);
    (0, react_1.useEffect)(() => {
        const sessionStorageRetailCustomerDetails = JSON.parse(sessionStorage.getItem(localStorageKey_1.TLocalStorageKey.RetailCustomerDetails));
        // check if we got something saved from the storage
        if (sessionStorageRetailCustomerDetails === null || sessionStorageRetailCustomerDetails === void 0 ? void 0 : sessionStorageRetailCustomerDetails.retailCustomerId) {
            setRetailCustomerDetails(sessionStorageRetailCustomerDetails);
        }
        else if (retailCustomerDetails) {
            sessionStorage.setItem(localStorageKey_1.TLocalStorageKey.RetailCustomerDetails, JSON.stringify(retailCustomerDetails));
        }
        setIsAccountVerificationRequired(!!(retailCustomerDetails === null || retailCustomerDetails === void 0 ? void 0 : retailCustomerDetails.retailCustomerId));
    }, [retailCustomerDetails]);
    if (retailCustomer) {
        return (React.createElement(React.Fragment, null,
            React.createElement(SlimSection_1.SlimSection, null,
                React.createElement(SlimSection_1.SlimSectionBody, null,
                    React.createElement("p", null,
                        "You are currently logged in as ",
                        retailCustomer.name,
                        ". Would you like to proceed?"),
                    React.createElement("p", { className: css("proceed") },
                        React.createElement(Button_1.Button, { onClick: tryToProceed },
                            "Proceed as ",
                            retailCustomer.firstName)))),
            React.createElement(SlimSection_1.SlimSection, null,
                React.createElement(SlimSection_1.SlimSectionBody, null,
                    React.createElement("h4", null, "Purchase as someone else?"),
                    React.createElement("p", null,
                        React.createElement("a", { onClick: () => client.auth.logout() }, "Log out"))))));
    }
    if (createNew) {
        return (React.createElement("div", { className: css("") },
            React.createElement(RetailCustomerCreateAccount_1.RetailCustomerCreateAccount, { onCompletion: retailCustomerDetails => {
                    if (retailCustomerDetails) {
                        // activate account verification modal
                        setRetailCustomerDetails(retailCustomerDetails);
                        // close signup modal
                        setCreateNew(false);
                    }
                } }),
            React.createElement(SlimSection_1.SlimSection, null,
                React.createElement(SlimSection_1.SlimSectionBody, null,
                    React.createElement("h4", null, "Already have an account?"),
                    React.createElement("p", null,
                        React.createElement("a", { onClick: () => setCreateNew(false) }, "Sign in here"))))));
    }
    if (resetPasswordRequest) {
        return (React.createElement("div", { className: css("") },
            React.createElement(RetailCustomerResetPasswordRequest_1.RetailCustomerResetPasswordRequest, null),
            React.createElement(SlimSection_1.SlimSection, null,
                React.createElement(SlimSection_1.SlimSectionBody, null,
                    React.createElement("h4", null, "Already have an account?"),
                    React.createElement("p", null,
                        React.createElement("a", { onClick: () => setResetPasswordRequest(false) }, "Sign in here"))))));
    }
    return (React.createElement("div", { className: css("") },
        isAccountVerificationRequired ? (React.createElement(RetailCustomerVerifyAccount_1.RetailCustomerVerifyAccount, { retailCustomerDetails: retailCustomerDetails, onCompletion: session => {
                if (session) {
                    // cleanup local storage
                    sessionStorage.removeItem(localStorageKey_1.TLocalStorageKey.RetailCustomerDetails);
                    // proceed to next step
                    tryToProceed();
                    // close modal
                    onSignUp && onSignUp();
                }
            } })) : (React.createElement(RetailCustomerLogin_1.RetailCustomerLogin, { onCompletion: retailCustomer => {
                if (retailCustomer) {
                    // if we get retail session, it means the customer has been already verified
                    if (retailCustomer instanceof RetailSession_1.RetailSession) {
                        tryToProceed();
                    }
                    else {
                        // we only receive the customer data (not the session one)
                        // then, we need to ask the customer to verify their phone number first
                        setRetailCustomerDetails({
                            retailCustomerId: retailCustomer.id,
                            mobileNumber: retailCustomer.mobileNumber
                        });
                        // then, resend a verification SMS message to customer's phone number
                        client.retailCustomers
                            .resendVerificationCode(retailCustomer.id)
                            .catch(console.warn);
                    }
                }
            } })),
        React.createElement(SlimSection_1.SlimSection, null,
            React.createElement(SlimSection_1.SlimSectionBody, null,
                React.createElement(Grid_1.Grid, null,
                    React.createElement(Card_1.Card, null,
                        React.createElement(Card_1.CardBody, null,
                            React.createElement("h4", null, "Forgot Password?"),
                            React.createElement("p", null,
                                React.createElement("a", { onClick: () => setResetPasswordRequest(true) }, "Reset Password")))),
                    React.createElement(Card_1.Card, null,
                        React.createElement(Card_1.CardBody, null,
                            React.createElement("h4", null, "Not Registered?"),
                            React.createElement("p", null,
                                React.createElement("a", { onClick: () => setCreateNew(true) }, "Create Account")))))))));
};
exports.RetailCustomerWrapper = RetailCustomerWrapper;
//# sourceMappingURL=index.js.map